import { CommonModule, NgClass } from '@angular/common';
import { Component, OnInit, Input, ElementRef, Renderer2, signal } from '@angular/core';
import { ResponsiveService } from '@core/services/responsive.service';
import { environment } from '@environments/environment';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LoadingIconComponent } from '../loading-icon/loading-icon.component';

@Component({
  selector: 'cgw-item-image',
  standalone: true,
  imports: [NgClass, LazyLoadImageModule, CommonModule, LoadingIconComponent],
  templateUrl: './item-image.component.html',
  styleUrls: ['./item-image.component.scss'],
})
export class ItemImageComponent implements OnInit {
  @Input() name: string;
  @Input() size: 'small' | 'medium' | 'large' | 'natural';
  @Input() absoutePath: boolean;
  @Input() transparent: boolean = false;
  @Input() alt: string;
  sizeTranslate: string;
  defaulttHeight: string;
  browserUse: string;
  srcPath: string;
  defaultImage: string;
  public isImageLoaded = signal<boolean>(false);
  public isImageError = signal<boolean>(false);

  public onImageLoad(): void {
    this.isImageLoaded.set(true);
  }
  public onImageError(): void {
    this.isImageLoaded.set(true);
  }
  constructor(
    private elRef: ElementRef,
    private render: Renderer2,
    private resolution: ResponsiveService,
  ) {
    this.defaultImage = environment.assetsImage;
  }

  public srcImg = environment.img;
  ngOnInit(): void {
    this.render.setStyle(this.elRef.nativeElement, 'display', 'inline-block');
    switch (this.size) {
      case 'small':
        this.sizeTranslate = '-mini';
        this.defaulttHeight = '89px';
        break;
      case 'medium':
        this.sizeTranslate = '-med';
        this.defaulttHeight = '150px';
        break;
      case 'large':
        this.sizeTranslate = '-grn';
        this.defaulttHeight = '450px';
        break;
      case 'natural':
        this.sizeTranslate = '';
        break;
      default:
        this.sizeTranslate = '-mini';
    }

    if (!this.resolution) {
      this.render.setStyle(this.elRef.nativeElement, 'height', this.defaulttHeight);
    }

    this.render.setStyle(this.elRef.nativeElement, 'position', 'relative');
    //this.render.setStyle(this.elRef.nativeElement, 'width', '100%');
    this.srcPath =
      this.absoutePath ? this.name : this.srcImg + this.name + this.sizeTranslate + '.jpg';
  }

  get computedClasses(): string[] {
    return [this.size || 'small', 'image-container'];
  }
}
